<!-- <pq-theme></pq-theme> -->
<pq-setting></pq-setting>
<pq-help *ngIf="!isAppPreview"></pq-help>
<kt-language-selector *ngIf="!isAppPreview"></kt-language-selector>
<user-profile></user-profile>
